import Modal from "components/HOCS/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectConfirmationModal,
  setConfirmationModal,
} from "slices/textSlice";

const ConfirmationModal = () => {
  const dispatch = useDispatch();
  const confirmModalThings = useSelector(selectConfirmationModal);

  const dismiss = () => {
    dispatch(setConfirmationModal(null));
  };

  if (
    confirmModalThings &&
    confirmModalThings.header &&
    confirmModalThings.content &&
    confirmModalThings.action
  ) {
    return (
      <Modal
        growth={false}
        noBackDropClick={false}
        lightBackDrop={confirmModalThings.danger ? false : true}
        header={
          confirmModalThings.danger ? (
            <div className="delete-text-color">{confirmModalThings.header}</div>
          ) : (
            confirmModalThings.header
          )
        }
        content={
          <>
            {confirmModalThings.content}
            <br />
            <br />
            <div>
              <div
                className="confirm-button w-25 d-inline-block"
                onClick={dismiss}
              >
                Cancel
              </div>
              <button
                className={`confirm-button business-button w-50 float-right ${
                  confirmModalThings.danger ? "delete-bg-color" : ""
                }`}
                onClick={() => {
                  dispatch(confirmModalThings.action);
                  dismiss();
                }}
              >
                Confirm
              </button>
            </div>
          </>
        }
        onDismiss={dismiss}
      />
    );
  } else {
    return null;
  }
};

export default ConfirmationModal;
